import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';

import { OrderConstructionStepsComponent } from '@components/orders/manage-orders/production-flow/order-construction-steps/order-construction-steps.component';
import { OrderMaterialsNeededComponent } from '@components/orders/manage-orders/production-flow/order-materials-needed/order-materials-needed.component';
import { OrderProductionDetailsComponent } from '@components/orders/manage-orders/production-flow/order-production-details/order-production-details.component';
import { OrderShippingDetailsComponent } from '@components/orders/manage-orders/production-flow/order-shipping-details/order-shipping-details.component';
import { OrderShippingViewComponent } from '@components/orders/manage-orders/production-flow/order-shipping-view/order-shipping-view.component';

import {
  ConstructionStepPayload,
  singleOrderDetails,
} from '../../../../@store/orders/orders.model';
import { SafeAny } from '../../../../types/safe-any';

@Component({
  selector: 'ciwc-production-flow',
  imports: [
    MatTabsModule,
    OrderProductionDetailsComponent,
    OrderConstructionStepsComponent,
    OrderMaterialsNeededComponent,
    OrderShippingDetailsComponent,
    OrderShippingViewComponent,
  ],
  standalone: true,
  templateUrl: './production-flow.component.html',
  styleUrl: './production-flow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductionFlowComponent {
  @Input() parentForm!: FormGroup;
  @Input() details: SafeAny;
  @Input() orderDetails!: singleOrderDetails;
  @Input() createShipmentGroup!: () => FormGroup;
  @Input() viewDisable!: boolean;
  @Input() itemProcesses: SafeAny = [];
  @Input() readonlySpecFields = false;

  @Output() constructionStepsChange: EventEmitter<ConstructionStepPayload[]> = new EventEmitter<
    ConstructionStepPayload[]
  >();

  // handle construction steps changes
  onConstructionStepsChange(steps: ConstructionStepPayload[]) {
    this.constructionStepsChange.emit(steps);
  }
}
